import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'
import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPackageReqCounts } from '../packageReqService'

export const usePkgReqCounts = (warehouse?: string) => {
  const { data: loggedUser } = useCurrentUser()
  const userWarehouse = loggedUser?.permissions['Admin'] ? '' : loggedUser?.warehouse
  const warehouseToUse = warehouse ?? userWarehouse ?? ''

  return useQuery({
    queryKey: [QUERY_KEYS.PACKAGE_REQUESTS, 'counts', warehouseToUse],
    queryFn: () => getPackageReqCounts(warehouseToUse),
  })
}
